import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MainComponent } from './main/main.component';
import { ProgressBarService } from './services/progressbar.service'
import { AdalService } from './adal/adal.service';
import { Cookie } from "ng2-cookies"

@Component({
    selector: 'devops-app',
    template: require('./app.component.html'),
    providers: [Cookie]
})
export class AppComponent {
    private sub: any;
    private userInfo: any;
    private showUser: boolean = false;

    constructor(
        private progressBarService: ProgressBarService,
        private router: Router,
        private adalService: AdalService

    ) {
        this.sub = this.router.events.subscribe(
            event => {
                if (event instanceof NavigationStart) {
                    this.progressBarService.start();
                }
                else if (event instanceof NavigationEnd ||
                    event instanceof NavigationCancel ||
                    event instanceof NavigationError) {
                    this.progressBarService.complete();
                }
            },
            (error: any) => {
                this.progressBarService.complete();
            });

        this.userInfo = this.adalService.userInfo;

        if (this.userInfo.isAuthenticated === true) {
            this.showUser = true;
        }
        else {
            this.showUser = false;
        }
    }

    public logout() {
        Cookie.deleteAll();
        this.adalService.logOut();
        this.adalService.clearCache();
        sessionStorage.clear();
    }

    toggleSidebar() {
        var page = document.getElementById('page');
        var sidebar = document.getElementById('sidebar');
        if (page.classList.contains('pageLeft')) {
            page.classList.remove('pageLeft');
            sidebar.classList.remove('moveLeft');
            page.classList.remove('col-xs-10');
            sidebar.classList.remove('col-xs-2');
            page.classList.add('col-xs-5');
            sidebar.classList.add('col-xs-7');
        }
        else {
            page.classList.add('pageLeft');
            sidebar.classList.add('moveLeft');
            page.classList.add('col-xs-10');
            sidebar.classList.add('col-xs-2');
            page.classList.remove('col-xs-5');
            sidebar.classList.remove('col-xs-7');
        }
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/app.component.ts
 **/